export const therapyConst = {
  path: "/single-programs/therapy",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ТЕРАПИЯ (по направлениям)",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Терапия — фундамент современной медицины</h2>
      <p>
        Терапия — это направление, которое охватывает диагностику, лечение и профилактику заболеваний внутренних органов у взрослых
        пациентов. Программа подготовки терапевтов в МЕУ включает как базовую терапевтическую практику, так и углубленное изучение
        профильных специальностей:
      </p>
      <p>гастроэнтерология, пульмонология, нефрология, ревматология, кардиология и другие.</p>
      <p>
        Образование по направлению «Терапия» — это путь к универсальности и гибкости в медицинской карьере, а также основа для последующей
        специализации.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Диагностику и лечение внутренних болезней</li>
        <li>Основы гастроэнтерологии, пульмонологии, нефрологии</li>
        <li>Кардиологию и ревматологию</li>
        <li>Клиническую фармакологию и лабораторную диагностику</li>
        <li>ЭКГ, УЗИ и другие методы функциональной диагностики</li>
        <li>Терапевтическую тактику при неотложных состояниях</li>
        <li>Коммуникацию с пациентами, медицинскую этику</li>
        <li>Ведение медицинской документации и стандарты ЕС</li>
      </ul>
      <p>Программа включает практические тренинги, стажировки в клиниках и участие в международных проектах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врачом-терапевтом (в поликлиниках и госпиталях)</li>
        <li>
          <p>Врачом узкой специализации (после дополнительной подготовки):</p>
          <ul>
            <li>гастроэнтерологом</li>
            <li>пульмонологом</li>
            <li>нефрологом</li>
            <li>ревматологом</li>
          </ul>
        </li>
        <li>Консультантом в сфере превентивной и семейной медицины</li>
        <li>Медицинским экспертом в страховых и фармацевтических организациях</li>
        <li>Преподавателем клинических дисциплин, научным сотрудником</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>от €55,000 до €100,000 в год</p>
      <p>Терапевты — одни из самых востребованных специалистов в системе здравоохранения Европы.</p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Очная и дистанционная форма обучения</li>
        <li>Практикоориентированная программа</li>
        <li>Стажировки в клиниках стран ЕС</li>
        <li>Обучение на русском или английском языке</li>
        <li>Поддержка куратора и помощь в трудоустройстве</li>
      </ul>
      <h2>Медицина начинается с терапии</h2>
      <p>Это профессия, требующая глубоких знаний, эмпатии и клинического мышления.</p>
      <p>Мы готовим врачей, способных принимать ответственные решения и быть поддержкой для пациентов на всех этапах лечения.</p>
      <br />
      <p className="padding-left">«Терапевт — это больше, чем врач. Это человек, который слышит, понимает и действует.»</p>
      <h2>Как поступить?</h2>
      <p>
        Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной
        комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Терапия — фундамент современной медицины
    Терапия — это направление, которое охватывает диагностику, лечение и профилактику заболеваний внутренних органов у взрослых пациентов.
    Программа подготовки терапевтов в МЕУ включает как базовую терапевтическую практику, так и углубленное изучение профильных специальностей:
    гастроэнтерология, пульмонология, нефрология, ревматология, кардиология и другие.
    Образование по направлению «Терапия» — это путь к универсальности и гибкости в медицинской карьере, а также основа для последующей специализации.

    Что вы будете изучать?
    Диагностику и лечение внутренних болезней
    Основы гастроэнтерологии, пульмонологии, нефрологии
    Кардиологию и ревматологию
    Клиническую фармакологию и лабораторную диагностику
    ЭКГ, УЗИ и другие методы функциональной диагностики
    Терапевтическую тактику при неотложных состояниях
    Коммуникацию с пациентами, медицинскую этику
    Ведение медицинской документации и стандарты ЕС
    Программа включает практические тренинги, стажировки в клиниках и участие в международных проектах.

    Кем можно работать после окончания?
    Врачом-терапевтом (в поликлиниках и госпиталях)
    Врачом узкой специализации (после дополнительной подготовки):
    гастроэнтерологом
    пульмонологом
    нефрологом
    ревматологом
    Консультантом в сфере превентивной и семейной медицины
    Медицинским экспертом в страховых и фармацевтических организациях
    Преподавателем клинических дисциплин, научным сотрудником

    Зарплата в Европе:
    от €55,000 до €100,000 в год
    Терапевты — одни из самых востребованных специалистов в системе здравоохранения Европы.

    Почему выбирают нас?
    Европейский диплом с международным признанием
    Очная и дистанционная форма обучения
    Практикоориентированная программа
    Стажировки в клиниках стран ЕС
    Обучение на русском или английском языке
    Поддержка куратора и помощь в трудоустройстве

    Медицина начинается с терапии
    Это профессия, требующая глубоких знаний, эмпатии и клинического мышления.
    Мы готовим врачей, способных принимать ответственные решения и быть поддержкой для пациентов на всех этапах лечения.
    «Терапевт — это больше, чем врач. Это человек, который слышит, понимает и действует.»

    Как поступить?
    Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы.
  `,
};
